/**
 * Returns a new array with unique items by a computed key.
 * Keeps the first occurrence of each key (so pre-sort your input if needed).
 */
export function dedupeByKey(items, getKey) {
  const map = new Map();

  for (const item of items) {
    const key = getKey(item);
    if (key === null || key === undefined || key === '') continue;
    if (!map.has(key)) map.set(key, item);
  }

  return Array.from(map.values());
}

